import { Fragment, useEffect } from 'react';
import { useLiveTutor } from '../../../hooks/LiveTutorProvider';


interface DescribeImageProps {
	image: { src: string; alt: string; };
	key_words?: string[];
}

const DescribeImage: React.FC<DescribeImageProps> = ({ image, key_words }) => {
	const { handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the instruction/question.", false);
	}, []);


	return (
		<div className="flex flex-col items-center space-y-4 md:space-y-6 max-w-2xl mx-auto p-3 md:p-6 bg-gray-50 rounded-xl shadow-md">
			<h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center">Describe the Picture</h2>

			{key_words && key_words.length > 0 && (
				<Fragment>

					<div className="w-full space-y-4">
						<p className="text-sm text-gray-700">
							Use the key words to help you.
						</p>
					</div>
					<div className="w-full">
						<p className="text-sm font-semibold text-gray-700 mb-1">Key words:</p>
						<div className="flex flex-wrap gap-2">
							{key_words.map((word: string, index: number) => (
								<span
									key={index}
									className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium hover:bg-blue-200 transition-colors duration-200"
								>
									{word}
								</span>
							))}
						</div>
					</div>
				</Fragment>
			)}

			<img
				src={image.src}
				alt={image.alt}
				className="w-full h-auto max-h-96 object-cover rounded-lg shadow-lg"
			/>
		</div>
	);
}


export default DescribeImage;